/**
 * @description : Oxygen MediaConnector Class
 * @date : 11/07/2020
 * @requires : OXYGENJANUSDL
 */
/**
 * @class MediaConnector
 * @params {parent}
 */
"use strict";

export default class MediaManager {
    constructor(config) {
      this.config = config;
      this.lib = window.top.LivingScript_0070;
      this.publishers = {
        Chat : {janusPub : null, State : false, EpisodeID : null, ParentSegment : null, ChildSegment : null, MediaFeedID : null, RemoteFeedID : null, janusServer : null, history : null, historyid : null, segmentTemplate : '_FFFFFFFFFFFFFF00001563968428258269_',eventTemplate:'_FFFFFFFFFFFFFF00001575595750910042_',registrantId:'_FFFFFFFFFFFFFF00001575882222359002_'},
        Audio : {janusPub : null, State : false, EpisodeID : null, ParentSegment : null, ChildSegment : null, MediaFeedID : null, RemoteFeedID : null, janusServer : null, history : null, historyid : null, segmentTemplate : '_FFFFFFFFFFFFFF00001570127778812311_',eventTemplate:'_FFFFFFFFFFFFFF00001575595750910042_',registrantId:'_FFFFFFFFFFFFFF00001575882222359002_'},
        Video : {janusPub : null, State : false, EpisodeID : null, ParentSegment : null, ChildSegment : null, MediaFeedID : null, RemoteFeedID : null, janusServer : null, history : null, historyid : null, segmentTemplate : '_FFFFFFFFFFFFFF00001565355394363351_',eventTemplate:'_FFFFFFFFFFFFFF00001575595750910042_',registrantId:'_FFFFFFFFFFFFFF00001575882222359002_'},
        Screen : {janusPub : null, State : false, EpisodeID : null, ParentSegment : null, ChildSegment : null, MediaFeedID : null, RemoteFeedID : null, janusServer : null, history : null, historyid : null, segmentTemplate : '_FFFFFFFFFFFFFF00001570127778812372_',eventTemplate:'_FFFFFFFFFFFFFF00001575595750910042_',registrantId:'_FFFFFFFFFFFFFF00001575882222359002_'},
        Data : {janusPub : null, State : false, EpisodeID : null, ParentSegment : null, ChildSegment : null, MediaFeedID : null, RemoteFeedID : null, janusServer : null, history : null, historyid : null, segmentTemplate : '_FFFFFFFFFFFFFF00001570567589543451_',eventTemplate:'_FFFFFFFFFFFFFF00001575595750910042_',registrantId:'_FFFFFFFFFFFFFF00001575882222359002_'},
        Pstn : {janusPub : null, State : false, EpisodeID : null, ParentSegment : null, ChildSegment : null, MediaFeedID : null, RemoteFeedID : null, janusServer : null, history : null, historyid : null, segmentTemplate : '_FFFFFFFFFFFFFF00001570127778812311_',eventTemplate:'_FFFFFFFFFFFFFF00001575595750910042_',registrantId:'_FFFFFFFFFFFFFF00001575882222359002_'}
      };

      this.subscribers = [];

      this.streaming = {}
    }

    init(config) {
      this.config = config;
      this.lib = window.top.LivingScript_0070;
    }

    publishMediaStart(event, publisherEvents, mediaStreamEvents, callback) {
      console.log("publishMediaStart Event : ", event, ":", this.config);
      if(!this.publishers[event.mediaType].janusPub) {
        if(event.mediaType == 'Pstn') {
          this.publishers[event.mediaType].janusPub = new OXYGENSIP(this);
          //this.publishers[event.mediaType].MediaFeedID = this.simplia.servernode;
        } else {
          this.publishers[event.mediaType].janusPub = new OXYGENJANUS(this);
        }
        //let gatewayArray = this.lib.oes.decode({ OES : event.context.GatewayPE });
        //let participantId = gatewayArray.Segments[3].String;
        //this.lib = window.top.LivingScript_0070; /* Temp Fix */
        let segmentId = this.lib.guid.generateSync();
        let serverInfo = this.config;
        let serverState = window.botStore.serverinfo.CurrentContext.ServerState;

        //console.log("Gateway Array : ", gatewayArray);
        this.publishers[event.mediaType].janusPub.init({
            channelId : (event.mediaType == 'Pstn') ? event.context.MeetingContext.MeetingId : Math.floor(Math.random()*10001),
            participantId : event.context.componentId,
            server : 'https://'+serverInfo.ServerODN+'.laxroute53.com:8089/janus',
            type : 'publisher' ,
            id : Math.floor(Math.random()*10001),
            segmentid : segmentId,
            mediatype: event.mediaType,
            record : false,
            vmflag : false,
            tope : event.context.ByPE,
            panelid : event.context.componentId,
            grantid : event.context.grantId,
            localip : (event.pstnContext && event.pstnContext.localip) ? event.pstnContext.localip : serverState.PrivateIpAddress,
            meetingId : event.context.MeetingContext.MeetingId,
            connect : true,
            context : event.context
          },
          [],
          callback,
          publisherEvents,
          mediaStreamEvents
        );

        console.log("publishMediaStart for : ", this.publishers);
      }
    }

    publishMediaStop(event, callback) {
      console.log("publishMediaStop for : ", this.publishers);
      if(event.MediaType && this.publishers[event.MediaType] && this.publishers[event.MediaType].janusPub) {
        if(event.MediaType == 'Pstn') {
          this.publishers[event.MediaType].janusPub.doHangup();
        } else {
          this.publishers[event.MediaType].janusPub.unpublishOwnFeed();
        }
        this.publishers[event.MediaType].janusPub.clean((err, res) => {
          console.log("Set janusPub Null");
        });
        setTimeout(this.cleanPublisher.bind(this), 3000, event.MediaType);
      } else {
        for(var mediaType in this.publishers) {
          if(this.publishers[mediaType].janusPub) {
            if(mediaType == 'Pstn') {
              this.publishers[mediaType].janusPub.doHangup();
            } else {
              this.publishers[mediaType].janusPub.unpublishOwnFeed();
            }
            this.publishers[mediaType].janusPub.clean((err, res) => {
              console.log("Set janusPub Null");
              //this.publishers[mediaType].janusPub = null;
            });
            setTimeout(this.cleanPublisher.bind(this), 3000, mediaType);
          }
        }
      }
    }

    recordingStart(event, callback) {
      console.log("recordingStart for : ", this.publishers);
      for(var mediaType in this.publishers) {
        if(this.publishers[mediaType].janusPub) {
          this.publishers[mediaType].janusPub.RecordingStart(window.LivingScript_0070.guid.generateSync(), callback);
        }
      }
    }

    recordingStop(event, callback) {
      console.log("recordingStart for : ", this.publishers);
      for(var mediaType in this.publishers) {
        if(this.publishers[mediaType].janusPub) {
          this.publishers[mediaType].janusPub.RecordingStop(callback);
        }
      }
    }

    cleanPublisher(mediaType) {
      if(mediaType && this.publishers[mediaType]) {
        if(this.publishers[mediaType].janusPub) {
          console.log("Set janusPub Null");
          this.publishers[mediaType].janusPub = null;
        }
      }
    }

    subscriberMediaStart(event, subscriberEvents, mediaStreamEvents, callback) {
      console.log("subscriberMediaStart Event: ", event);
      let subscriber = new OXYGENJANUS(this);

      subscriber.init(
          {
            channelId : parseInt(event.MediaFeedID, 10),
            participantId : event.Client,
            participantName : event.GrantLeftDN,
            server : event.Channel,
            type : 'subscriber' ,
            feed : parseInt(event.RemoteFeedID, 10),
            mediatype : event.MediaType,
            panelid: event.context.componentId,
            grantid : event.GrantLeftID,
            tope : event.ToPE,
            meetingId : event.Conference,
            capabilities : JSON.parse(event.GatewayJson)
          },
          [],
          callback,
          subscriberEvents,
          mediaStreamEvents
      );

      this.subscribers.push(subscriber);
    }

    subscribeMediaStop() {
      this.subscribers.forEach((subscriber) => {
        console.log("Cleaning Subscriber : ", subscriber);
        if(subscriber) {
          subscriber.subClean();
          subscriber = null;
        }
      });
    }

    stopCall() {
      for(var mediaType in this.publishers) {
        if(this.publishers[mediaType].janusPub) {
          this.publishers[mediaType].janusPub.unpublishOwnFeed();
          this.publishers[mediaType].janusPub = null;
        }
      }

      this.subscribers.forEach((subscriber) => {
        if(subscriber) {
          console.log("Cleaning Subscriber : ", subscriber);
          subscriber.subClean();
          subscriber = null;
        }
      });
    }

    cleanSubsciber(event) {
      console.log("MediaManager clean subscriber got :", event, this.subscribers);
      this.subscribers.forEach((subscriber) => {
        if(subscriber) {
          if(subscriber.channelServer == event.ChannelServerID && subscriber.channelSession == event.ChannelSessionID) {
            subscriber.subClean();
            subscriber = null;
          }
        }
      });
    }

    startMediaStream(data) {
      console.log("startMediaStream Event: ", data);
      this.streaming['test'] = new OXYGENSTREAM(this);
      console.log(this.streaming['test']);
      let serverInfo = this.config.CurrentContext.ServerState;
      this.streaming['test'].init(
        {
          participantId : data.componentId,
          grantid : data.grantid,
          mediatype : 'Stream',
          context : data,
          server : 'https://'+serverInfo.PublicDnsName+':8089/janus',
          create : true
        },
        [],
        ()=>{},
        ()=>{},
        ()=>{}
      );
    }

    sendData(event) {
      if(this.publishers[event.mediaType].janusPub) {
        this.publishers[event.mediaType].janusPub.sendData(event.data);
      }
    }

    sendDtmf(event) {
      console.log("sendDtmf Event: ", event);
      if(event.mediaType == 'Pstn' && this.publishers[event.mediaType].janusPub) {
        this.publishers[event.mediaType].janusPub.sendDtmf(event.data);
      }
    }

    setCapbilities(event) {
      if(this.publishers[event.MediaType].janusPub) {
        this.publishers[event.MediaType].janusPub.setCapbilities(event);
      }
    }

    getPublisherStates() {
      let states = {};
      for(var mediaType in this.publishers) {
        if(this.publishers[mediaType].janusPub) {
          states[mediaType] = true;
        } else {
          states[mediaType] = false;
        }
      }
      return states;
    }

    mutePublisher(event, callback) {
      if(event.MediaType && this.publishers[event.MediaType]) {
        if(this.publishers[event.MediaType].janusPub) {
          if(event.MediaType == 'Audio') {
            this.publishers[event.MediaType].janusPub.AudioToggle(false, callback);
          }
        }
      }
    }

    unmutePublisher(event, callback) {
      if(event.MediaType && this.publishers[event.MediaType]) {
        if(this.publishers[event.MediaType].janusPub) {
          if(event.MediaType == 'Audio') {
            this.publishers[event.MediaType].janusPub.AudioToggle(true, callback);
          }
        }
      }
    }

    pauseSubscriber(event) {
      console.log("MediaManager pauseSubscriber got :", event, this.subscribers);
    }

    unpauseSubscriber(event) {
      console.log("MediaManager unpauseSubscriber got :", event, this.subscribers);
    }
}
